<div id="pgh-floating-chat-button" [style.display]="isChatButtonHidden() ? 'none' : 'block'">
  @if(buttonVisibility()) {
    <button sf-aria-label="Global_Loading_Aria_Label" class="chat-button d-flex align-items-center justify-content-center" type="button"
      (click)="openChat()">
      <mat-icon class="d-flex align-items-center justify-content-center" svgIcon="asapp-chat"></mat-icon>
    </button>
  }
</div>
